import React, { useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import CardBox from '../components/cards/cards';
import TextFieldCustom from '../components/textFiled/input';
import { validNationalId } from "../../../method/validNarionalId/index";
import { getCaptcha } from "../../../../redux/captchaPouyan/getcaptcha";
import { Formik, FormikHelpers, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { base64File } from "../../../method/fineBase64file/finebase64file";
import { Button, CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { send_otp_sejam } from "../../../../redux/register/sejam/send_otp_ssejam/sendOtpSejam";
import { useDispatch } from "react-redux";
import { notificationAlertErrorApi } from './../../../method/notificationAlertErrorApi/notificationAlertErrorApi'
import { actionTypes as actionTypesNotif } from './../../../../redux/notificationAlert/index';
import { send_otp_chang_oms_api } from "../../../../redux/services/senUpdateTradingSystemOtp/senUpdateTradingSystemOtp";
import { convertDigitToEnglish } from "../../../method/convertDigitToEnglish";
import { convertPersianToEnglishDigits } from "../../../method/converter/converterText";



let useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },
    gridTilte: {
        fontSize: 16,
        marginBottom: 10,
        marginTop: 80,
        maxWidth: '100%',
        "@media(max-width : 505px)": {
            fontSize: 14,
            minWidth: '100%',
        },
    },
    desc: {
        marginBottom: '16px',
        fontWeight: 'bold',

    },
    textError: {
        color: '#E60001',
        fontSize: 12,
        fontWeight: 400,
        position: 'absolute',
        paddingTop: 5,
        paddingRight: 10,
    },
    errorTextfield: {
        color: '#E60001',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid red'
        }
    },
    TextFieldCaptcha: {
        '& .MuiOutlinedInput-root fieldset': {
            borderColor: 'red',
        },
    },
    gridTextField: {
        marginBottom: 24
    },
    TextField: {
        width: '100%',
    },
    gridCaptcha: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "100% !important",
        minHeight: "40px !important",
    },
    textHelp: {
        color: "#ADADAD",
        fontSize: 13

    },
    iconRefresh:{
        cursor:'pointer'
    }
}))



const Index = () => {

    let classes = useStyles();
    const formikRef = useRef();

    const location = useLocation();
    let dispatch = useDispatch();
    const navigate = useHistory();

    const { national_id  , servics} = location.state?.state ||location.state || {};


    const initialValues = {
        national_id: null,
        captcha: {
            token: null,
            src: null,
            value: null,
        },
    };


    const validationSchema = Yup.object().shape({
        national_id: Yup.string()
            .matches(/^[0-9]{10}$/, "کد ملی باید ۱۰ رقم باشد")
            .transform(convertPersianToEnglishDigits)
            .test("isValidNationalId", "کد ملی نادرست است!", (value) =>
                value ? validNationalId(value) : false
            )
            .required('کد ملی الزامی است'),

        captcha: Yup.object({
            value: Yup.string()
                .required('مقدار کپچا الزامی است'),
        })

    });

    const handleSubmit = (values, { setSubmitting }) => {

        setSubmitting(true);
        apiSubmitSendOtpSejam(values, setSubmitting)
    };


    const getCaptchMehtod = () => {
        getCaptcha()
            .then((res) => {
                if (res?.data?.data?.token) {
                    let setFieldValue = formikRef?.current?.setFieldValue
                    setFieldValue('captcha', {
                        token: res?.data.data.token,
                        src: base64File(res?.data?.data.fileData),
                        value: null,
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching captcha:', error);
            });
    };


    useEffect(() => {
        getCaptchMehtod()
        return () => { }
    }, [])


    useEffect(() => {
        if (national_id) {
            let setFieldValue = formikRef?.current?.setFieldValue
            setFieldValue('national_id', national_id)
        }
    }, [national_id])


    const apiSubmitSendOtpSejam = (values, setSubmitting) => {

        setSubmitting(true)

        let payload = {
            data: {
                NationalCode: convertDigitToEnglish(values?.national_id),
            },
            headers: {
                'captcha-value': convertDigitToEnglish(values?.captcha?.value),
                'captcha-token': values?.captcha?.token,
            }
        }

        if(servics === 'sejam'){
            apiSejam(payload , values , setSubmitting)
        }

        if(servics === 'changeOms'){
            apiChangeOms(payload , values , setSubmitting)
        }


    }


    const apiSejam = (payload ,values,setSubmitting )=>{
        send_otp_sejam(payload)
        .then((res) => {
            if (res?.status === 200 && res?.data?.data.sendOTPStatus) {
                navigate.push('/register/otp', {
                    national_id: values?.national_id,
                    message: res?.data?.data?.message,
                    servics: 'sejam',
                    data:{
                        ...res?.data?.data
                    }
                });
            }
            if (res?.data?.data?.message) {
                dispatch(({ type: actionTypesNotif.warning, textAlert: res?.data?.data?.message }))
                getCaptchMehtod()
            }
        })
        .catch((error) => {

            if (error?.response?.data?.code === 1302 ||
                error?.response?.data?.message === "برای ثبت نام در کارگزاری می بایست ابتدا در سامانه سجام ثبت نام کنید."
            ) {
                navigate('/register/sejam', { state: {... location.state  } });
                return
            }

            notificationAlertErrorApi(error, dispatch)
            getCaptchMehtod()
            formikRef.current.setFieldValue('captcha.value', '');


        })
        .finally(() => {
            setSubmitting(false)
        })
    }

    const apiChangeOms = (payload ,values,setSubmitting )=>{
        send_otp_chang_oms_api(payload)
        .then((res) => {
            if (res?.status === 200 && res?.data.sendOTPStatus) {
                navigate.push('/register/otp', {
                    national_id: values?.national_id,
                    message: res?.data?.message,
                    servics: 'changeOms',
                    data:{
                        ...res?.data
                    }
                });
            }
            if (res?.data?.data?.message) {
                dispatch(({ type: actionTypesNotif.warning, textAlert: res?.data?.data?.message }))
                getCaptchMehtod()
            }
        })
        .catch((error) => {

            if (error?.response?.data?.code === 1302 ||
                error?.response?.data?.message === "برای ثبت نام در کارگزاری می بایست ابتدا در سامانه سجام ثبت نام کنید."
            ) {
                navigate('/register/sejam', { state: {... location.state  } });
                return
            }

            notificationAlertErrorApi(error, dispatch)
            getCaptchMehtod()
            formikRef.current.setFieldValue('captcha.value', '');


        })
        .finally(() => {
            setSubmitting(false)
        })
    }


    return (
        <CardBox>
            <div className={classes['root']}>
                <div className={classes['gridTilte']}>
                    <p className={classes['desc']}>
                        درصورتی‌که در سامانه سجام ثبت‌نام کرده‌اید. اطلاعات خود را وارد نمایید.
                        {/* <span className={classes['textHelp']}>
                            راهنما
                        </span> */}
                    </p>
                </div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    className={classes['root']}
                    innerRef={formikRef}
                >
                    {({ isSubmitting, errors, touched, values, setFieldValue }) => {

                        return (
                            <>
                                <div className={classes['gridTextField']}>
                                    <TextFieldCustom
                                        label={''}
                                        placeholder={'کد ملی'}
                                        dataForm={{
                                            id: 'national_id',
                                            isSubmitting: isSubmitting,
                                            errors: errors,
                                            touched: touched,
                                        }}
                                        inputProps={{ inputMode: 'numeric' }}
                                    />
                                </div>
                                <div className={classes['gridTextField']}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label=""
                                        placeholder="کد امنیتی"
                                        value={values?.captcha?.value ? values?.captcha?.value : null}
                                        onChange={(e) => setFieldValue('captcha.value', e.target.value)}
                                        onKeyUp={(event) => (event.key === 'Enter') ? formikRef.current?.submitForm() : ''}
                                        className={classes['TextField']}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div className={classes['gridCaptcha']}>
                                                        {
                                                            values?.captcha?.src && <img src={values?.captcha?.src} alt="captcha" style={{ height: 35 }} />
                                                        }
                                                        <img src={"/assets/icons/refresh.svg"} alt="" className={classes['iconRefresh']}
                                                            onClick={() => getCaptchMehtod()}
                                                        />
                                                    </div>
                                                </InputAdornment>
                                            ),
                                            className: errors?.captcha && touched?.captcha ? classes['errorTextfield'] : '',
                                            style: {
                                                width: '100%',
                                                height: 42,
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root fieldset': {
                                                borderColor: errors?.captcha && touched?.captcha ? 'red' : ''
                                            },
                                        }}
                                    />
                                    <ErrorMessage className={classes['textError']} name="captcha.value" component="div" />
                                </div>
                                <div className={classes['gridBtns']}>
                                    <Button
                                        className={classes.customButton}
                                        variant="contained"
                                        disabled={isSubmitting}
                                        style={{ color: 'white' }}
                                        onClick={() => formikRef.current?.submitForm()}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                در حال ارسال
                                                <CircularProgress size={24} className={classes.progress} />
                                            </>
                                        ) : (
                                            "ادامه"
                                        )}
                                    </Button>
                                </div>
                            </>

                        )
                    }}
                </Formik>
            </div>
        </CardBox>
    )
}

export default Index                          